"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _removeMarkdown = _interopRequireDefault(require("remove-markdown"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

// formats the metadata
function meta(frontMatter) {
  var description = frontMatter.description,
      path = "https://docs.mapbox.com/".concat(frontMatter.pathname);
  description += "\n\nSee the example: [".concat(path, "](").concat(path, ")");
  return {
    title: frontMatter.title,
    description: description,
    tags: ['mapbox', 'maps']
  };
} // creates a form wrapper for each platform


var Form = /*#__PURE__*/function (_React$Component) {
  _inherits(Form, _React$Component);

  var _super = _createSuper(Form);

  function Form() {
    _classCallCheck(this, Form);

    return _super.apply(this, arguments);
  }

  _createClass(Form, [{
    key: "render",
    value: function render() {
      var classes = "inline-block";
      if (this.props.classes) classes += " ".concat(this.props.classes);
      return /*#__PURE__*/_react.default.createElement("form", {
        className: classes,
        method: "POST",
        action: this.props.action,
        target: "_blank"
      }, this.props.children);
    }
  }]);

  return Form;
}(_react.default.Component); // creates the actual button that the user can click


var Button = /*#__PURE__*/function (_React$Component2) {
  _inherits(Button, _React$Component2);

  var _super2 = _createSuper(Button);

  function Button() {
    _classCallCheck(this, Button);

    return _super2.apply(this, arguments);
  }

  _createClass(Button, [{
    key: "render",
    value: function render() {
      var platform = this.props.platform;
      var btnClass = 'btn btn--s cursor-pointer round';
      return /*#__PURE__*/_react.default.createElement("input", {
        style: {
          border: 0
        },
        type: "submit",
        className: btnClass,
        value: "Edit in ".concat(platform),
        onClick: function onClick() {
          if (window && window.analytics) {
            analytics.track("Clicked Edit in ".concat(platform));
          }
        }
      });
    }
  }]);

  return Button;
}(_react.default.Component);

var Edit = /*#__PURE__*/function (_React$Component3) {
  _inherits(Edit, _React$Component3);

  var _super3 = _createSuper(Edit);

  function Edit() {
    _classCallCheck(this, Edit);

    return _super3.apply(this, arguments);
  }

  _createClass(Edit, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          css = _this$props.css,
          js = _this$props.js,
          html = _this$props.html,
          head = _this$props.head,
          resources = _this$props.resources,
          frontMatter = _this$props.frontMatter;
      var projectMeta = meta(frontMatter);
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(Form, {
        action: "https://jsfiddle.net/api/post/library/pure/"
      }, /*#__PURE__*/_react.default.createElement(Button, {
        platform: "JSFiddle"
      }), /*#__PURE__*/_react.default.createElement("input", {
        type: "hidden",
        name: "wrap",
        value: "b"
      }), /*#__PURE__*/_react.default.createElement("input", {
        type: "hidden",
        name: "css",
        value: css
      }), /*#__PURE__*/_react.default.createElement("input", {
        type: "hidden",
        name: "html",
        value: html
      }), /*#__PURE__*/_react.default.createElement("input", {
        type: "hidden",
        name: "js",
        value: js
      }), /*#__PURE__*/_react.default.createElement("input", {
        type: "hidden",
        name: "title",
        value: projectMeta.title
      }), /*#__PURE__*/_react.default.createElement("input", {
        type: "hidden",
        name: "resources",
        value: resources ? resources.js.concat(resources.css) : []
      }), /*#__PURE__*/_react.default.createElement("input", {
        type: "hidden",
        name: "description",
        value: (0, _removeMarkdown.default)(projectMeta.description)
      })), /*#__PURE__*/_react.default.createElement(Form, {
        classes: "ml6",
        action: "https://codepen.io/pen/define"
      }, /*#__PURE__*/_react.default.createElement("input", {
        type: "hidden",
        name: "data",
        value: JSON.stringify({
          title: projectMeta.title,
          html: html,
          html_pre_processor: 'none',
          description: projectMeta.description,
          tags: projectMeta.tags,
          css: css,
          css_pre_processor: 'none',
          js: js,
          js_pre_processor: 'none',
          css_external: resources && resources.css ? resources.css.join(';') : '',
          js_external: resources && resources.js ? resources.js.join(';') : '',
          head: head
        })
      }), /*#__PURE__*/_react.default.createElement(Button, {
        platform: "CodePen"
      })));
    }
  }]);

  return Edit;
}(_react.default.Component);

exports.default = Edit;
Form.propTypes = {
  children: _propTypes.default.node.isRequired,
  action: _propTypes.default.string.isRequired,
  classes: _propTypes.default.string
};
Button.propTypes = {
  platform: _propTypes.default.oneOf(['JSFiddle', 'CodePen']).isRequired
};
Edit.propTypes = {
  css: _propTypes.default.string.isRequired,
  // CSS panel contents
  js: _propTypes.default.string.isRequired,
  // JS panel contents
  html: _propTypes.default.string.isRequired,
  // HTML panel contents
  head: _propTypes.default.string,
  // extra html to add to the head of the document (CodePen)
  frontMatter: _propTypes.default.shape({
    title: _propTypes.default.string.isRequired,
    description: _propTypes.default.string.isRequired,
    pathname: _propTypes.default.string.isRequired
  }),
  resources: _propTypes.default.shape({
    // absolute URLs to CDNs
    js: _propTypes.default.array,
    css: _propTypes.default.array
  })
};